import React from 'react';
import loadingStyle from '../LoadingOverlay.module.css'

const Circle = () => {

    return (
        <circle cx='50' cy='50' r='20' fill='none' strokeWidth='2' className={loadingStyle.circleLoading}
                strokeMiterlimit='10'/>
    )
}

export default Circle;
